import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { AuthenticationService } from '../shared/services/authentication.service';

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {

  constructor(private authService: AuthenticationService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // add authorization header with jwt token if available
    const currentUser = this.authService.currentUserValue;
    const csrfToken = currentUser ? currentUser.token : null;
    if (csrfToken) {
      const cloned = req.clone({ setHeaders: { 'X-CSRF-TOKEN': csrfToken } });
      return next.handle(cloned);
    }
    return next.handle(req);
  }
}
